// Gera data: URL com avatar circular + iniciais + halo do status do técnico.
// Pra usar como icon do Google Maps Marker.

const CORES_STATUS = {
  em_rota:        { halo: '#22c55e', haloOpacity: 0.20 },
  atendendo:      { halo: '#3b82f6', haloOpacity: 0.20 },
  pausa:          { halo: '#fbbf24', haloOpacity: 0.20 },
  ocioso:         { halo: '#94a3b8', haloOpacity: 0.20 },
  parado_alerta:  { halo: '#ef4444', haloOpacity: 0.30 },
  sem_gps:        { halo: '#cbd5e1', haloOpacity: 0.15 },
};

/**
 * @param {string} iniciais  ex: "JS"
 * @param {string} corAvatar cor do círculo (hex)
 * @param {string} statusCalc em_rota/atendendo/pausa/ocioso/parado_alerta/sem_gps
 * @param {boolean} pulsar    halo pulsa (apenas em parado_alerta no Google Maps
 *                            o SVG anima sozinho)
 */
export function gerarAvatarSvg(iniciais, corAvatar = '#f97316', statusCalc = 'ocioso') {
  const c = CORES_STATUS[statusCalc] || CORES_STATUS.ocioso;
  const animar = statusCalc === 'parado_alerta';
  const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" width="56" height="56">
  <circle cx="28" cy="28" r="${animar ? 24 : 22}" fill="${c.halo}" fill-opacity="${c.haloOpacity}">
    ${animar ? '<animate attributeName="r" values="22;26;22" dur="1.8s" repeatCount="indefinite"/>' : ''}
  </circle>
  <circle cx="28" cy="28" r="17" fill="white" stroke="${c.halo}" stroke-width="3"/>
  <circle cx="28" cy="28" r="14" fill="${corAvatar}"/>
  <text x="28" y="32" text-anchor="middle" font-family="-apple-system,BlinkMacSystemFont,Roboto,sans-serif"
        font-size="11" font-weight="700" fill="white">${iniciais}</text>
</svg>`.trim();
  // URL-encode mas mantém os caracteres ASCII básicos
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
}

/**
 * Gera pin SVG para visita (círculo colorido por status_visual)
 */
export function gerarPinVisitaSvg(statusVisual) {
  const CORES = {
    concluida:               '#22c55e',  // verde — finalizada
    em_andamento:            '#3b82f6',  // azul — compat com snapshot antigo (genérico)
    em_andamento_no_horario: '#3b82f6',  // azul — atendimento pontual
    em_andamento_atrasada:   '#f97316',  // laranja — em atendimento, mas iniciou >10min atrasado
    proxima_2h:              '#fbbf24',  // amarelo — vai começar em <2h
    atrasada:                '#ef4444',  // vermelho pulsando — janela passou, não iniciou
    agendada:                '#94a3b8',  // cinza claro — futura
    cancelada:               '#d1d5db',  // cinza muito claro — cancelada
  };
  const cor = CORES[statusVisual] || '#94a3b8';
  const tamanho = statusVisual === 'atrasada' ? 22 : 18;
  const pulse = statusVisual === 'atrasada';
  const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="${tamanho}" height="${tamanho}">
  ${pulse ? `<circle cx="14" cy="14" r="12" fill="${cor}" fill-opacity="0.35">
    <animate attributeName="r" values="10;14;10" dur="1.5s" repeatCount="indefinite"/>
    <animate attributeName="fill-opacity" values="0.35;0;0.35" dur="1.5s" repeatCount="indefinite"/>
  </circle>` : ''}
  <circle cx="14" cy="14" r="9" fill="${cor}" stroke="white" stroke-width="2.5"/>
</svg>`.trim();
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
}
